import { useNavigate, Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from './AuthProvider';
import BaseApp from './base';
import PageLoader from 'components/PageLoader';
import logger from 'utils/logger';
import { IWG_GROUP } from './constants';

// Create a logger instance for this component
const log = logger.createLogger('ProtectedAdminRoute');

// Protected Route Component
const ProtectedAdminRoute = () => {
  const { isAuthenticated, userGroups, currentUserInfo, isLoading } = useAuth();
  const navigate = useNavigate();
  // For some reason on the first load, the user is not authenticated
  // So we need to check if the user is authenticated
  useEffect(() => {
    if (!isLoading) {
      const currentPath = window.location.pathname;
      if (!isAuthenticated) {
        if (currentPath !== '/login') {
          log.info('Not authenticated');
          navigate('/login');
        }
      } else if (!userGroups?.includes(IWG_GROUP)) {
        // If user is not an admin, redirect to regular dashboard
        if (!currentPath.startsWith('/dashboard')) {
          log.info('Not admin, redirecting to /dashboard');
          navigate('/dashboard/home');
        }
      } else if (userGroups?.includes(IWG_GROUP)) {
        if (!currentPath.startsWith('/admin/dashboard')) {
          log.info('Admin user, redirecting to /admin');
          navigate('/admin/dashboard/users');
        }
      }
    }
  }, [isAuthenticated, isLoading, navigate, userGroups]);

  if (isLoading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <BaseApp>
      <Outlet context={{ isAuthenticated, currentUserInfo }} />
    </BaseApp>
  );
};
export default ProtectedAdminRoute;
